import { OS } from '../types/env';

/**
 * 获取当前系统类型
 */
export const getOs = (): OS => {
  const ua = window.navigator.userAgent;
  let os = OS.other;
  if (ua.indexOf('Android') > -1) {
    os = OS.android;
  } else if (/(iPhone|iPod|iPad)/.test(ua)) {
    os = OS.ios;
  }
  return os;
};

/**
 * 当前系统类型是否为IOS
 */
export const isIos = (): boolean => getOs() === OS.ios;

/**
 * 当前系统类型是否为安卓
 */
export const isAndroid = (): boolean => getOs() === OS.android;

/**
 * 腾讯视频极速版ua标记
 */
export const isQQLite = (): boolean => {
  const ua = window.navigator.userAgent;
  return ua.indexOf('QQLiteBrowser') > -1;
};

/**
 * 腾讯视频ua标记
 */
export const isQQLive = (): boolean => {
  const ua = window.navigator.userAgent;
  return ua.indexOf('QQLiveBrowser') > -1 || ua.indexOf('QQLiveHDBrowser') > -1;
};

/**
 * 判断是否是 内广webview
 * 内广webview 潜在视频app中，ua会有视频的标记，但是不能使用视频的jsbridge
 * 当普通浏览器来处理
 */
export const isTadChid = (): boolean => {
  const ua = window.navigator.userAgent;
  return ua.indexOf('TadChid') > -1 || ua.indexOf('TADChid') > -1;
};

/**
 * 判断是否为 腾讯视频极速版APP
 */
export const isLiteTenvideo = (): boolean => isQQLite() && !isTadChid();

/**
 * 判断是否为 腾讯视频APP
 */
export const isTenvideo = (): boolean => isQQLive() && !isTadChid() && !isLiteTenvideo();
